import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchTickets } from '../api/api';
import TicketCard from '../components/TicketCard';
import './History.css';

const normalizeTicket = (t) => ({
  id: t.id,
  subject: t.title,
  title: t.title,
  description: t.description,
  status: (t.status || 'open').replace('-', ' '),
  priority: (t.priority || 'medium').toLowerCase(),
  customerName: 'You',
  createdAt: t.created_at || t.createdAt,
  replies: 0,
});

const History = () => {
  const navigate = useNavigate();
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchTickets()
      .then((data) => { if (!cancelled) setTickets(Array.isArray(data) ? data : []); })
      .catch(() => { if (!cancelled) setTickets([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const sorted = [...tickets].sort((a, b) => new Date(b.created_at || b.createdAt) - new Date(a.created_at || a.createdAt));
  const normalized = sorted.map(normalizeTicket);

  return (
    <div className="history-screen">
      <h1 className="history-title">Complaint History</h1>
      {loading ? (
        <p className="history-loading">Loading...</p>
      ) : normalized.length > 0 ? (
        <div className="history-list">
          {normalized.map((ticket) => (
            <div key={ticket.id} onClick={() => navigate(`/user/tickets/${ticket.id}`)} style={{ cursor: 'pointer', marginBottom: 12 }}>
              <TicketCard ticket={ticket} />
            </div>
          ))}
        </div>
      ) : (
        <p className="history-empty">No complaints yet.</p>
      )}
    </div>
  );
};

export default History;
